import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchproductsRequest } from 'store/products/actions';
import { useNavigate } from 'react-router-dom';
import { getStays } from 'store/stays/selectors';

const useQueryProducts = (locationTag: string) => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const location = useSelector(getStays);
  const path = window.location.href;
  useEffect(() => {
    dispatch(
      fetchproductsRequest({
        location_tag: locationTag,
        category: location?.default_category, // Default category can be adjusted as needed
        history,
        path,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?._id]);
};

export default useQueryProducts;
